import { render, staticRenderFns } from "./ResearcherClaimVersion.vue?vue&type=template&id=1be3f379&scoped=true&"
import script from "./ResearcherClaimVersion.vue?vue&type=script&lang=js&"
export * from "./ResearcherClaimVersion.vue?vue&type=script&lang=js&"
import style0 from "./ResearcherClaimVersion.vue?vue&type=style&index=0&id=1be3f379&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be3f379",
  null
  
)

export default component.exports